module.exports = __webpack_public_path__ + "static/media/cart-full.2eb35880.svg";